var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _g, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSber2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 26,
    viewBox: "0 0 129 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_12377)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6308 8.01084L79.1618 5.40234H67.3438V21.0688H79.1618V18.4603H70.7167V14.4494H77.9206V11.8409H70.7167V8.01084H75.6308Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4226 11.5092H54.3182V8.01084H60.8706L64.4017 5.40234H50.9453V21.068H57.9877C61.9374 21.068 64.2032 19.2744 64.2032 16.1465C64.2032 13.1563 62.1505 11.5092 58.4226 11.5092ZM57.8355 18.4603H54.3182V14.1177H57.8355C59.9767 14.1177 60.9738 14.8439 60.9738 16.2886C60.9738 17.7651 59.9174 18.4603 57.8355 18.4603Z",
    fill: "#21A038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7354 5.40234H82.3008V21.068H85.6737V16.6306H88.7354C92.8416 16.6306 95.3927 14.4666 95.3927 11.0087C95.3927 7.55082 92.8416 5.40234 88.7354 5.40234ZM88.6632 14.0221H85.6737V8.01084H88.6632C90.8242 8.01084 92.0147 9.07819 92.0147 11.0165C92.0147 12.9548 90.8242 14.0221 88.6632 14.0221Z",
    fill: "#21A038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1548 17.6764C44.2901 18.1545 43.2827 18.4077 42.2435 18.4077C39.2023 18.4077 36.9959 16.2325 36.9959 13.2355C36.9959 10.2385 39.2032 8.06334 42.2435 8.06334C43.3936 8.06334 44.425 8.38725 45.3112 9.02559L47.73 7.23892L47.5702 7.0985C46.1579 5.85456 44.2703 5.19727 42.1128 5.19727C39.7722 5.19727 37.6474 5.98808 36.1311 7.425C34.6054 8.86966 33.7656 10.9027 33.7656 13.1494C33.7656 15.4064 34.6028 17.4696 36.1225 18.9582C37.6474 20.452 39.7671 21.2747 42.0913 21.2747C44.523 21.2747 46.6461 20.4253 48.085 18.879C46.9745 18.0588 45.9026 17.2672 45.9026 17.2672L45.1548 17.6764Z",
    fill: "#21A038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2968 5.05078C23.9113 5.84425 24.4363 6.71088 24.8555 7.63602L13.0052 16.3685L8.05469 13.2652V9.53192L13.0052 12.6352L23.2968 5.05078Z",
    fill: "#21A038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00367 12.9994C3.00367 12.8315 3.00797 12.6655 3.01658 12.4994L0.0163526 12.3496C0.00602476 12.5648 0 12.7816 0 12.9994C0 16.5906 1.45536 19.842 3.80924 22.1948L5.93677 20.0675C4.1251 18.2568 3.00367 15.7567 3.00367 12.9994Z",
    fill: "url(#paint0_linear_707_12377)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0053 23.0013C12.8374 23.0013 12.6713 22.997 12.5052 22.9884L12.3555 25.9884C12.5706 25.9987 12.7875 26.0048 13.0053 26.0048C16.5968 26.0048 19.8483 24.5495 22.2013 22.1958L20.0738 20.0684C18.263 21.8791 15.7628 23.0013 13.0053 23.0013Z",
    fill: "url(#paint1_linear_707_12377)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0053 23.0013C12.8374 23.0013 12.6713 22.997 12.5052 22.9884L12.3555 25.9884C12.5706 25.9987 12.7875 26.0048 13.0053 26.0048C16.5968 26.0048 19.8483 24.5495 22.2013 22.1958L20.0738 20.0684C18.263 21.8791 15.7628 23.0013 13.0053 23.0013Z",
    fill: "url(#paint2_linear_707_12377)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0047 3.00044C13.1725 3.00044 13.3386 3.00647 13.5047 3.01421L13.6544 0.0124453C13.4393 0.00211815 13.2224 -0.00390625 13.0047 -0.00390625C9.41316 -0.00390625 6.16161 1.45136 3.80859 3.8051L5.93612 5.9325C7.74693 4.1218 10.248 3.00044 13.0047 3.00044Z",
    fill: "url(#paint3_linear_707_12377)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0014 23.0013C12.8335 23.0013 12.6674 22.997 12.5013 22.9884L12.3516 25.9884C12.5667 25.9987 12.7836 26.0048 13.0014 26.0048C16.5929 26.0048 19.8444 24.5495 22.1974 22.1958L20.0699 20.0684C18.2591 21.8791 15.7589 23.0013 13.0014 23.0013Z",
    fill: "#A3CD39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0693 20.0684L22.1968 22.1958C21.7686 22.6241 21.3106 23.0227 20.8263 23.3881L19.7695 20.356C19.8714 20.2622 19.9714 20.1663 20.0693 20.0684Z",
    fill: "#21A038"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_12377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 11,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0014 23.0013C12.8335 23.0013 12.6674 22.997 12.5013 22.9884L12.3516 25.9884C12.5667 25.9987 12.7836 26.0048 13.0014 26.0048C16.5929 26.0048 19.8444 24.5495 22.1974 22.1958L20.0699 20.0684C18.2591 21.8791 15.7589 23.0013 13.0014 23.0013Z",
    fill: "#A3CD39"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_12377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_707_12377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 10,
    height: 7
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 20.3008,
    width: 3.99732,
    height: 7.40868,
    transform: "rotate(70.7786 19.75 20.3008)",
    fill: "url(#paint4_linear_707_12377)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_707_12377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 20.3008,
    width: 3.99732,
    height: 7.40868,
    transform: "rotate(70.7786 19.75 20.3008)",
    fill: "#21A038"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6459 4.74573L21.1754 2.88168C18.9429 1.07786 16.1019 -0.00390625 13.0078 -0.00390625V3.00044C15.0983 3.00044 17.04 3.64503 18.6459 4.74573Z",
    fill: "url(#paint5_linear_707_12377)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.01 13.0015C26.01 12.2063 25.9386 11.4275 25.8018 10.6719L23.0021 12.7347C23.0047 12.8234 23.0055 12.912 23.0055 13.0015C23.0055 15.9379 21.7335 18.5825 19.7109 20.4138L21.7292 22.6445C24.3585 20.2658 26.01 16.8269 26.01 13.0015Z",
    fill: "#21A038"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.003 23.0014C10.0664 23.0014 7.42165 21.7294 5.59018 19.707L3.35938 21.7251C5.73907 24.3534 9.17824 26.0049 13.003 26.0049V23.0014Z",
    fill: "url(#paint6_linear_707_12377)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29824 5.59005L4.28002 3.35938C1.65159 5.73893 0 9.17789 0 13.0024H3.00453C3.00367 10.066 4.27572 7.4214 6.29824 5.59005Z",
    fill: "url(#paint7_linear_707_12377)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.985 20.9818H116.684V5.61328H123.358C126.783 5.61328 128.539 6.88668 128.539 9.43347C128.539 11.1899 127.837 12.3535 126.256 12.9682C128.144 13.2976 129 14.5051 129 16.503C129 19.6865 126.717 20.9818 122.985 20.9818ZM119.428 18.457H123.16C125.268 18.457 126.234 17.7764 126.234 16.3054C126.234 14.8344 125.136 14.2636 123.204 14.2636H119.428V18.457ZM119.428 12.112H122.963C124.697 12.112 125.795 11.3436 125.795 10.0263C125.795 8.79677 124.983 8.13812 123.029 8.13812H119.428V12.112Z",
    fill: "#21A038"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.984 20.9822V19.1379C109.285 13.715 110.339 12.266 110.339 10.4657C110.339 8.97274 109.395 8.09454 107.705 8.09454C105.904 8.07258 104.565 8.97274 103.489 10.334V7.0846C104.236 6.27226 105.86 5.41602 108.056 5.41602C111.349 5.43797 113.084 7.17242 113.084 9.93876C113.084 12.749 111.547 14.7908 107.002 18.4573H113.347V20.9822H102.984Z",
    fill: "#21A038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_12377",
    x1: 4.41646,
    y1: 21.8193,
    x2: 1.1341,
    y2: 12.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3037,
    stopColor: "#E7E518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5823,
    stopColor: "#CADB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_707_12377",
    x1: 12.1575,
    y1: 24.1927,
    x2: 21.7185,
    y2: 22.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    stopColor: "#86C339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#21A038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_707_12377",
    x1: 12.1575,
    y1: 24.1927,
    x2: 21.7185,
    y2: 22.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    stopColor: "#86C339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#21A038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_707_12377",
    x1: 4.66683,
    y1: 4.33716,
    x2: 13.1216,
    y2: 1.11501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0592,
    stopColor: "#0FA8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5385,
    stopColor: "#0099F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    stopColor: "#0291EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_707_12377",
    x1: 21.7487,
    y1: 20.3008,
    x2: 21.7487,
    y2: 27.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_707_12377",
    x1: 12.3793,
    y1: 1.00323,
    x2: 20.5537,
    y2: 3.52556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    stopColor: "#0291EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C8ACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_707_12377",
    x1: 4.11276,
    y1: 21.36,
    x2: 13.0106,
    y2: 24.6848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1324,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2977,
    stopColor: "#EBE716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#D9E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8023,
    stopColor: "#BBD62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_707_12377",
    x1: 1.11835,
    y1: 13.3668,
    x2: 4.68968,
    y2: 4.07584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#81C55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    stopColor: "#0FA8E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_12377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSber2B);
export default __webpack_public_path__ + "static/media/sber-2-b.588930063c7d6970550a8be1786e5ae4.svg";
export { ForwardRef as ReactComponent };